import { applyToOpening as applyToOpeningCallable } from "./functions";
import { trackEvent } from "./elearning";

/**
 * Submit an application for an open position. No auth required (applicants
 * typically aren't signed in). Server validates + dedupes + writes to
 * `applicants` and sends a confirmation email.
 *
 * Returns { ok: true, id } on success. Throws on validation or network errors.
 */
export async function applyToOpening(payload) {
  if (!payload || typeof payload !== "object") throw new Error("payload required");
  if (!payload.openingId) throw new Error("openingId required");
  if (!payload.name) throw new Error("name required");
  if (!payload.email) throw new Error("email required");
  const res = await applyToOpeningCallable(payload);
  return res || { ok: false };
}

export { trackEvent };
